import { Component, ChangeDetectionStrategy } from '@angular/core';
import {MatDialogRef} from '@angular/material/dialog';

@Component({
  selector: 'app-custom-tip-dialog',
  templateUrl: './custom-tip-dialog.component.html',
  styleUrls: ['./custom-tip-dialog.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CustomTipDialogComponent {

  tipValue = 0;
  tipOptions = { prefix: '', thousands: '', decimal: '.', precision: 2, align: 'left' };

  constructor(public dialogRef: MatDialogRef<CustomTipDialogComponent>) {}
}
